import axios from "axios";
import { LawGarant } from "../pages/LawsGarantPage/Law";

const fetchGarantLaws = async (
  limit: number,
  nextPageToken?: string | null
) => {
  const response = await axios.get(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/garant?itemsPerPage=${limit}&PageToken=${nextPageToken ?? ""}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }
  );
  return response.data;
};
const searchGarantLaws = async (search: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/garant/search?query=${search}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }
  );
  return response.data;
};

const fetchGarantLawById = async (id: number) => {
  const response = await axios.get<{
    items: { number: number; text: string }[] | null;
  }>(`${process.env.REACT_APP_BACKEND_URL}/garant/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  });
  return response.data;
};
const fetchGarantLawByTopic = async (topic: number) => {
  const response = await axios.get<{
    items: { number: number; text: string }[] | null;
  }>(`${process.env.REACT_APP_BACKEND_URL}/garant/topic?topic=${topic}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  });
  return response.data;
};

const addNewGarantLaw = async (data: LawGarant) => {
  const formData = new FormData();

  // Add text fields
  formData.append("title", data.title);
  formData.append("topic", data.topic.toString());
  formData.append("display_order", data.display_order.toString());

  // Add file if it exists
  if (data.text && data.text instanceof FileList) {
    formData.append("text", data.text[0]);
  }

  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/garant`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
  return response.data;
};

const updateGarantLaw = async (
  data: Pick<LawGarant, "id" | "title" | "topic" | "text" | "display_order">
) => {
  const formData = new FormData();

  // Add text fields
  formData.append("id", data.id.toString());
  formData.append("title", data.title);
  formData.append("topic", data.topic.toString());
  formData.append("display_order", data.display_order.toString());

  // Add file if it exists
  if (data.text && data.text instanceof FileList) {
    formData.append("text", data.text[0]);
  }

  const response = await axios.put(
    `${process.env.REACT_APP_BACKEND_URL}/garant`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
  return response.data;
};

const removeGarantLaw = async (data: Pick<LawGarant, "id">) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BACKEND_URL}/garant/${data.id}`,
    {
      data: { id: data.id },
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }
  );
  return response.data;
};

export {
  fetchGarantLaws,
  addNewGarantLaw,
  removeGarantLaw,
  updateGarantLaw,
  fetchGarantLawById,
  searchGarantLaws,
  fetchGarantLawByTopic,
};
